import React, { useEffect } from "react";

const GoogleAd = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("Error cargando el anuncio:", e);
    }
  }, []);

  return (
    <ins className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-5767533952554403"
      data-ad-slot="4033749743"
      data-ad-format="auto"
      data-full-width-responsive="true">
    </ins>
  );
};

export default GoogleAd;
